import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=3014dcca"
import script from "./servers.vue?vue&type=script&lang=ts"
export * from "./servers.vue?vue&type=script&lang=ts"
import style0 from "./servers.vue?vue&type=style&index=0&id=3014dcca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports